import { Route, Switch, useRouteMatch } from 'react-router'
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  MembershipsTable,
  PassesTable,
  SubscriptionsFailedPaymentsTable,
} from '@sweetspot/club-portal/feature/subscriptions-tables'

const Subscriptions = () => {
  const { path } = useRouteMatch()

  const isMemberships = path.includes('memberships')
  const isPasses = path.includes('passes')

  return (
    <Switch>
      <Route exact path={`${path}/failed-payments`} component={SubscriptionsFailedPaymentsTable} />
      {isMemberships && <Route path={`${path}`} component={MembershipsTable} />}
      {isPasses && <Route path={`${path}`} component={PassesTable} />}
    </Switch>
  )
}

export { Subscriptions }
